import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveUsuarioSistema } from '../../shared';
import { useGetUsuarioSistema } from '@/shared/actions/erp/administration/usuarios';

export type UpdateUsuarioSistemaPageProps = {};

const UpdateUsuarioSistemaPage: React.FC<
  UpdateUsuarioSistemaPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.auth_change_user);
  const returnUrlUsuariosSistemaPage =
  ROUTER_PATHS.administration.usuariosNav;

  const { id } = useParams();

  const { data, isLoading, isRefetching } = useGetUsuarioSistema(+id!);

  if (isLoading || isRefetching) return <LoaderComponent />;
  if (!data?.data?.id)
    return <Navigate to={returnUrlUsuariosSistemaPage} replace={true} />;

  return (
    <>
      <SaveUsuarioSistema
        title="Actualizar Usuario de Sistema"
        systemUsuer={data.data}
      />
    </>
  );
};

export default UpdateUsuarioSistemaPage;
